<template>
  <ion-menu content-id="contentMain" menu-id="menuMain" side="start">
    <ion-header>
      <ion-toolbar color="primary">
        <ion-item color="primary">
          <ion-thumbnail slot="end">
            <img v-if="!currentUser.photoUrl" src="../assets/model_space_icon_reverse.png" />
            <img v-if="currentUser.photoUrl" :src="currentUser.photoUrl" />
          </ion-thumbnail>
          <ion-label text-wrap>
            <p class="h-f-m">Logged in as</p>
            <h3 class="h-f-b app-menu-heading" v-html="currentUser.displayName"></h3>
          </ion-label>
        </ion-item>
      </ion-toolbar>
    </ion-header>

    <ion-content color="dark">
      <ion-list lines="full" class="app-menu ion-no-padding">
        <ion-item
          color="dark"
          v-for="(item, index) in menuItems"
          v-bind:key="index"
          @click="open(item.path)"
        >
          <font-awesome-icon slot="start" v-bind:icon="item.icon"></font-awesome-icon>
          <ion-label>{{ item.title }}</ion-label>
        </ion-item>

        <ion-item color="dark" @click="logout()">
          <font-awesome-icon slot="start" icon="sign-out-alt"></font-awesome-icon>
          <ion-label>Logout</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>
</template>

<script>
import firebase from "firebase";
import intercomApiService from "../services/IntercomApi";
import { Plugins } from "@capacitor/core";

const { Storage } = Plugins;

export default {
  name: "app-menu",
  data() {
    return {
      isLoggedIn: false,
      currentUser: false,
      menuItems: this.menu()
    };
  },
  created() {
    if (firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser;
    }
  },
  methods: {
    open(screen) {
      this.$router.push(screen).catch(error => {
        // Error caught as navigating to same screen throws error.
        // eslint-disable-next-line
        console.log(error.message);
      });

      document.querySelector("ion-menu-controller").close("start");
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(async () => {
          await Storage.remove({ key: "pushToken" });
          await Storage.remove({ key: "pushTokenSet" });
          intercomApiService.logout();
          this.$router.go({ path: this.$router.path });
        });
    },
    menu() {
      return [
        {
          path: "/",
          icon: "home",
          title: "Dashboard"
        },
        {
          path: "/earnings",
          icon: "money-bill-wave",
          title: "Earnings"
        },
        {
          path: "/shifts",
          icon: "calendar-alt",
          title: "Shifts"
        },
        {
          path: "/support",
          icon: "users",
          title: "Support"
        },
        {
          path: "/resources",
          icon: "school",
          title: "Resources"
        },
        {
          path: "/account",
          icon: "user-cog",
          title: "Account"
        }
      ];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.svg-inline--fa {
  font-size: 18px;
  margin-right: 16px;
}

.app-menu-heading {
  font-size: 22px;
}
</style>
